import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

export const seperateSlotsByTimeOfDay = (
  slots: number[],
  timezone: string,
) => {
  const morningSlots: number[] = [];
  const afternoonSlots: number[] = [];
  const eveningSlots: number[] = [];

  for (let i = 0; i < slots.length; i++) {
    const slotHour = dayjs.unix(slots[i]).tz(timezone).hour();
    switch (true) {
    case slotHour < 12 && slotHour >= 4:
      morningSlots.push(slots[i]);
      break;
    case slotHour < 17 && slotHour >= 12:
      afternoonSlots.push(slots[i]);
      break;
    case slotHour > 17 && slotHour < 4:
      eveningSlots.push(slots[i]);
      break;
    default:
      eveningSlots.push(slots[i]);
      break;
    }
  }

  return {
    morningSlots,
    afternoonSlots,
    eveningSlots,
  };
};

